var d = /* @__PURE__ */ ((i) => (i.Android = "android", i.Epic = "epic", i.iOS = "ios", i.Mac = "mac", i.SkyMavis = "sky_mavis", i.Window = "win", i))(d || {});
export {
  d as PlatformType
};
//# sourceMappingURL=platform.js.map
